<template>
  <van-popup v-model="isShowClip" :lock-scroll="false" position="right" :style="{width: '100%', height: '100%'}">
    <div class="clip-container">
      <MyHeader title="编辑图片" :back="cancel" />

      <div style="width:100%;height:500px">
        <vueCropper ref="cropper" :img="option.img" :output-type="option.outputType" :full="option.full" :fixed="option.fixed"
          :can-scale="true" :can-move="true" :can-move-box="option.canMoveBox" :fixed-box="option.fixedBox"
          :auto-crop="option.autoCrop" :center-box="option.centerBox" :fixed-number="option.fixedNumber"></vueCropper>
      </div>

      <p class="clip-tips">可双指缩放图片</p>

      <div class="btns">
        <a href="javascript:;" class="cancel-btn btn" @click="cancel">取消</a>
        <a href="javascript:;" class="done-btn btn" @click="done">完成</a>
      </div>
    </div>
  </van-popup>
</template>
<script>
import MyHeader from '@/components/common/myHeader'
import { VueCropper } from 'vue-cropper'

export default {
  name: 'Clip',
  components: {
    MyHeader,
    VueCropper
  },
  props: {
    isShowClip: Boolean,
    img: {}
  },
  model: {
    prop: 'isShowClip',
    event: 'close'
  },
  watch: {
    img (val) {
      if (val) {
        setTimeout(() => {
          this.covert(val)
        }, 50)
      }
    }
  },
  data () {
    return {
      result: '',
      name: '',
      // 配置参考 vueCropper
      option: {
        img: '',
        size: 1,
        outputType: 'png',
        full: true,
        autoCrop: true,
        fixed: true,
        canScale: true,
        canMoveBox: false,
        fixedBox: true,
        centerBox: false,
        fixedNumber: [1, 0.7]
      }
    }
  },
  methods: {
    covert (file) {
      this.name = file.name
      let width = window.innerWidth * 0.8
      let height = width * 0.7
      this.option.img = URL.createObjectURL(file)
      // this.$refs.cropper.startCrop()
    },
    cancel () {
      this.$emit('close', false)
    },
    done () {
      this.$refs.cropper.getCropBlob((data) => {
        this.$emit('clipComplete', {
          data
        })
      })
    }
  }
}
</script>

<style lang="scss">
@import "@/assets/scss/constant.scss";
.clip-container {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  .header {
    flex: 0 0 88px;
  }
  .cropper-box {
    background: #fff;
  }
  .clip-tips {
    // flex: 0 0 40px;
    position: sticky;
    bottom: 112px;
    color: #fff;
    font-size: 28px;
    line-height: 56px;
    text-align: center;
  }
  .btns {
    position: fixed;
    bottom: 0;
    left: 0;
    width: 100%;
    z-index: 10;
    flex: 0 0 112px;
    font-size: 0;
  }
  .btn {
    display: inline-block;
    width: 50%;
    font-size: 32px;
    line-height: 112px;
    text-align: center;
  }
  .done-btn {
    color: #fff;
    background: $mainColor;
  }
  .cancel-btn {
    color: #4a4a4a;
    background: #fff;
  }
}
</style>
